<div class="closed-month">
    {{
        'SHOP.SHARED.EVENTS.DAY_OUT_OF_LIMITS'
            | translate
                : {
                      monthStatus:
                          ((selectedMonth.status === monthEventsStatusEnum.CLOSED
                              ? 'SHOP.SHARED.EVENTS.CLOSED'
                              : selectedMonth.status === monthEventsStatusEnum.OPEN
                              ? 'SHOP.SHARED.EVENTS.ACTIVE'
                              : 'SHOP.SHARED.EVENTS.INACTIVE'
                          ) | translate)
                  }
    }}
</div>

<div class="text-box">
    <h4>{{ 'SHOP.SHARED.EVENTS.DISABLE_MONTH.DISCLAIMER' | translate }}</h4>
    <p class="text">{{ selectedMonthName | translate }}.</p>
</div>

<div class="closed-month">
    {{ 'SHOP.SHARED.EVENTS.REFUND_DISCLAIMER' | translate }}
</div>
